var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18.05,
    viewBox: "0 0 19 18.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-flight",
    "data-name": "Icon material-flight",
    transform: "translate(22 -3) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M15.27,13.5",
    transform: "translate(-4.499 -3.85)",
    fill: "#b9b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M21.05,16.3V14.4l-7.6-4.75V4.425a1.425,1.425,0,1,0-2.85,0V9.65L3,14.4v1.9l7.6-2.375V19.15L8.7,20.575V22l3.325-.95L15.35,22V20.575l-1.9-1.425V13.925Z",
    fill: "#b9b5b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.7d855d7162ebcaeab15906e74e3774aa.svg";
export { ForwardRef as ReactComponent };